// extracted by mini-css-extract-plugin
export default {"region":"BannerRegion_region__NeTMT"};